import { CURRENT_SECONDARY_BRAND } from '@/config'; // h5 tab bar 路由

export var MAIN_TAB_BAR = [{
  title: '首页',
  to: {
    path: '/home'
  },
  icon: 'icon-home',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614746_pre$prod-ubq'
}, {
  title: '市场',
  to: {
    name: 'Market',
    path: '/auction/market'
  },
  icon: 'icon-market',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614853_pre$prod-ubq'
}, {
  title: '',
  to: {
    name: 'SearchPage',
    path: '/auction/searchPage'
  },
  icon: '',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614900_pre$prod-ubq'
}, {
  title: '发现',
  to: {
    name: 'FindIndex',
    path: '/find'
  },
  icon: 'icon-bands1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614920_pre$prod-ubq'
}, {
  title: '我的',
  to: {
    name: 'AccountIndex',
    path: '/account/index'
  },
  icon: 'icon-me',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001671614936_pre$prod-ubq'
}]; // 品牌馆 tab bar 路由

export var BRAND_TAB_BAR = [{
  title: '主页',
  to: {
    // name: 'BrandDetails',
    path: '/brand/details'
  },
  icon: 'icon-erjizhuye',
  activeIcon: 'icon-erjizhuye-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001673935493_pre$prod-ubq'
}, {
  title: '市场',
  to: {
    name: 'BrandMarket',
    path: '/auction/brandMarket',
    query: {
      storeNo: "".concat(CURRENT_SECONDARY_BRAND.storeNo),
      storeName: "".concat(CURRENT_SECONDARY_BRAND.storeName)
    }
  },
  icon: 'icon-erjishichang',
  activeIcon: 'icon-erjishichang-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001673935493_pre$prod-ubq'
}, {
  title: '发现',
  to: {
    name: 'FindIndex',
    path: '/find'
  },
  icon: 'icon-erjifaxian',
  activeIcon: 'icon-erjifaxian-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001673935493_pre$prod-ubq'
}, {
  title: '我的',
  to: {
    name: 'AccountIndex',
    path: '/account/index'
  },
  icon: 'icon-erjiwode',
  activeIcon: 'icon-erjiwode-1',
  skinImg: 'https://obs.prod.ubanquan.cn/obs_382703526000001673935493_pre$prod-ubq'
}];